import i18n from "i18next";

export const isVariationAvailable = (
  value: number | null | undefined
): value is number =>
  value !== null && value !== undefined && !Number.isNaN(value);

export const variationNotAvailableLabel = (): string =>
  i18n.t("Common-VariationNotAvailable");

export const formatVariation = (
  value: number | null | undefined,
  decimals = 1,
  suffix = "%"
): string => {
  if (!isVariationAvailable(value)) return variationNotAvailableLabel();
  return `${value >= 0 ? "+" : ""}${value.toFixed(decimals)}${suffix}`;
};
